module.exports = __webpack_public_path__ + "img/3H.f77c2c27.png";